import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Services from "../pages/services/page";
import SoftwareServices from "../pages/software-services/page";
import Training from "../pages/training/page";
import About from "../pages/about/page";
import Cases from "../pages/cases/page";
import CaseDetail from "../pages/cases/detail/page";
import Contact from "../pages/contact/page";
import BlogList from "../pages/blog/page";
import BlogArchive from "../pages/blog/archive/page";
import BlogDetail from "../pages/blog/detail/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/software-services",
    element: <SoftwareServices />,
  },
  {
    path: "/training",
    element: <Training />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/cases",
    element: <Cases />,
  },
  {
    path: "/cases/:id",
    element: <CaseDetail />,
  },
  {
    path: "/blog",
    element: <BlogList />,
  },
  {
    path: "/blog/archive",
    element: <BlogArchive />,
  },
  {
    path: "/blog/:slug",
    element: <BlogDetail />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
